declare function require(moduleName: string): any;

export const environment = {
  production: false,
  web: false,
  VERSION: require('../../package.json').version,

  stripeKey: 'pk_test_5A6XGN0bDlWavqZ1niqtQ4oJ',
};
